import { IconButton } from '@material-ui/core';
import ArrowBackRoundedIcon from '@material-ui/icons/ArrowBackRounded';
import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded';

import { SText } from '@setvi/shared/components';

import { useStyles } from '../../styles';

interface PreviewPagerProps {
  label: string;
  prevDisabled: boolean;
  nextDisabled: boolean;
  onPrev: () => void;
  onNext: () => void;
}

/** Previous / "label · page x of y" / next. */
export const PreviewPager = ({
  label,
  prevDisabled,
  nextDisabled,
  onPrev,
  onNext
}: PreviewPagerProps) => {
  const classes = useStyles();

  return (
    <>
      <IconButton
        className={classes.toolbarButton}
        size="small"
        disabled={prevDisabled}
        onClick={onPrev}>
        <ArrowBackRoundedIcon fontSize="small" />
      </IconButton>
      <SText title={label} size="sm" fontColor="#5D7083" maxLines={1} />
      <IconButton
        className={classes.toolbarButton}
        size="small"
        disabled={nextDisabled}
        onClick={onNext}>
        <ArrowForwardRoundedIcon fontSize="small" />
      </IconButton>
    </>
  );
};
